export function validateAccessToken(send) {
  return (body, headers, ...args) =>
    send(
      {
        path: '/v1/validate',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: headers,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
